module.exports = {"441823100":"青莲镇","441823101":"江英镇","441823104":"杜步镇","441823105":"七拱镇","441823107":"太平镇","441823108":"杨梅镇","441823110":"大崀镇","441823111":"小江镇","441823113":"岭背镇","441823115":"黄坌镇","441823116":"黎埠镇","441823119":"阳城镇","441823201":"秤架瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441823.json
// module id = 1875
// module chunks = 0